export enum ExpeditionConfirmationSource {
  CustomerButton = "CustomerButton",
  CustomerAi = "CustomerAi",
  AdminFallback = "AdminFallback"
}

export const EXPEDITION_CONFIRMATION_SOURCE_LABEL: Record<
  ExpeditionConfirmationSource,
  string
> = {
  [ExpeditionConfirmationSource.CustomerButton]:
    "Customer confirmed via WhatsApp",
  [ExpeditionConfirmationSource.CustomerAi]:
    "Customer confirmed via WhatsApp (AI)",
  [ExpeditionConfirmationSource.AdminFallback]: "Admin force-closed"
};
